export interface OperationsTeam {
  _id: string;
  name: string;
  userIds: string[];
  outstandingBalance: number;
}

export const mapOperationsTeamResponse = (response: any): OperationsTeam => {
  return {
    _id: response._id,
    name: response.name,
    userIds: response.userIds || [],
    outstandingBalance: response.outstandingBalance ?? 0,
  };
};

export const mapOperationsTeamsResponse = (response: any): OperationsTeam[] => {
  if (!response.data || !Array.isArray(response.data?.operationsTeams)) {
    return [];
  }
  return response.data.operationsTeams.map(mapOperationsTeamResponse);
};
